;(() => {
  const REVEAL_DELAY = 10000
  const DISMISS_PATH = "/suppress_banners/usage_tip/tip_filter-settings"
  const TIP_KEY = "filter-settings"
  const HIDDEN_CLASS = "hidden"
  const TIP_SELECTOR = ".usage-tip--container_filter-settings"

  // Module-scoped: one acknowledgement retires every tip on the page, and a
  // second one reports nothing because it never rendered again.
  let acknowledged = false

  stimulusApp.register(
    "usage-tip",
    class extends Stimulus.Controller {
      static targets = ["tip"]

      #revealTimer
      #revealed = false

      connect() {
        this.#scheduleReveal()
        document.addEventListener("click", this.#dismissOnOuterClick)
      }

      disconnect() {
        clearTimeout(this.#revealTimer)
        document.removeEventListener("click", this.#dismissOnOuterClick)
      }

      // `filter-settings#toggle` stops propagation, so the chevron never reaches
      // the outer-click listener.
      panelToggle() {
        if (this.#visible) {
          this.#acknowledge()
          return
        }

        this.#scheduleReveal()
      }

      dismiss() {
        this.#acknowledge()
      }

      // The tip sits inside the row's `<label>`, whose default action would
      // toggle the filter, and its own clicks must not read as outer ones.
      absorbClick(event) {
        event.preventDefault()
        event.stopPropagation()
      }

      // A morph that rebuilds the row rather than matching it brings in a fresh
      // hidden tip, which has to pick up the state the old one carried.
      tipTargetConnected(tip) {
        tip.classList.toggle(HIDDEN_CLASS, acknowledged || !this.#revealed)
      }

      #dismissOnOuterClick = () => {
        if (this.#visible) this.#acknowledge()
      }

      #scheduleReveal() {
        clearTimeout(this.#revealTimer)
        if (acknowledged || this.element.dataset.open !== "true") return

        this.#revealTimer = setTimeout(() => {
          if (acknowledged) return

          this.#revealed = true
          this.tipTargets.forEach((tip) => tip.classList.remove(HIDDEN_CLASS))
        }, REVEAL_DELAY)
      }

      #acknowledge() {
        if (acknowledged) return

        acknowledged = true
        this.#revealed = false
        document
          .querySelectorAll(TIP_SELECTOR)
          .forEach((tip) => tip.classList.add(HIDDEN_CLASS))
        RailsRequest.post(DISMISS_PATH)
        Activity.track("ux", "usage-tip", TIP_KEY)
      }

      get #visible() {
        return !this.tipTarget.classList.contains(HIDDEN_CLASS)
      }
    },
  )
})()
